export const APP_NAME = "PT HS BUDIMAN 45";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
